import { Component, Output, EventEmitter } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ODataService } from '@ui-kit/odata';
import { AssetsDataService } from 'src/services/assets-data.service';

@Component({
  selector: 'medical-appointments-list',
  templateUrl: './list.html',
  styles: [`
  
  .k-grid { height: 'auto'; }

  @media (max-width: 768px) {
    .k-grid { height: 280px; }
  }

  `]
})
export class MedicalAppointmentsListComponent {

  @Output() dataSelected: EventEmitter<any> = new EventEmitter<any>()

  public selectableSettings: SelectableSettings = { enabled: true, mode: 'single' }
  public mySelection: any[] = []
  public medAppointments$ = this.getMedicalAppointments()


  constructor(private odata: ODataService, private servAssetsData: AssetsDataService) { }


  public selectionChange(event: any) {
    let selectedData = event.selectedRows.length > 0 ? event.selectedRows[0].dataItem : null
    this.dataSelected.emit(selectedData)
  }



  private getMedicalAppointments() : Observable<any> {
    return forkJoin({
      astraApps: this.odata.get('medicalAppointments/getAvailableAppointments()', { 
          params: {
            select: [ 'id', 'scheduleId', 'serviceProviderTitle', 'specialtyTitle' ],
            orderBy: ['specialtyTitle asc', 'serviceProviderTitle asc' ],
          }}),
      assets: this.servAssetsData.texts$,
    })
    .pipe(map((o: any) => {
      const oo = [
        ...o.astraApps.map((oo: any) => {  
          return { 
            id: oo.id,
            scheduleId: oo.scheduleId,
            serviceProviderTitle: oo.serviceProviderTitle, 
            specialtyTitle: oo.specialtyTitle,
            doctorAndSpecialty: `${oo.serviceProviderTitle}, ${oo.specialtyTitle}`,
          }}),
        ...(o.assets?.externalDoctorSchedulesUrls ?? []).map((oo: any) => {
          return {
            id: oo.id,
            serviceProviderTitle: oo.pib, 
            specialtyTitle: oo.speciality,
            doctorAndSpecialty: `${oo.pib}, ${oo.speciality}`,
            url: oo.url,
          }}),
      ]

      if (oo.length > 0) {
        this.mySelection = [oo[0].id]
        this.dataSelected.emit(oo[0])
      }

      return oo
    }))
  }
}
